export const Bio = {
  name: "HIMANSHU SHARMA",
  roles: [
    "Front-end Developer!",
    "Full Stack Developer!",
    "Programmer!",
    "Software Developer!",
  ],
  description:
    "I hold a Bachelor's in Computer Science Engineering and continually expand my skills through courses, specializing in Data Structures and Web Development. Proficient in React.js, Node.js, MongoDB, and more, I excel in crafting user-friendly interfaces. I'm eager to contribute to projects. Outside academy, I enjoy exploring new tech and coding projects.",
  resume:
    "https://drive.google.com/file/d/1Gs_A4QZrtkz_6OWkZDt6T6U0EarvVQ4d/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/himanshusharmaz",
  insta: "https://www.instagram.com/himanshusharmaz/",
  leetcode: "https://leetcode.com/HimanshuSharmaz/",
  github: "https://github.com/HimanshuSharmax",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "https://mui.com/static/logo.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },
      {
        name: "Appwrite",
        image: "https://www.vectorlogo.zone/logos/appwriteio/appwriteio-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
    {
    title: "Course Work",
    skills: [
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/1853px-C_Programming_Language.svg.png",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/32/C%2B%2B_logo.png",
      },
      {
        name: "DSA",
        image:
          "https://static.studytonight.com/css/resource.v3/icons/subject/logo-ds.svg",
      },
      {
        name: "DBMS",
        image:
          "https://miro.medium.com/v2/resize:fit:515/1*L77-BAYNEflJ8lDHQWaH-Q.jpeg",
      },
      {
        name: "OOPS",
        image:
          "https://www.shutterstock.com/image-vector/oop-object-oriented-programming-acronym-260nw-2032420412.jpg",
      },
      {
        name: "Operating Systems",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXBvyXqDHjQUB1ujdjWdQo4geCu96U3YBAeQKRPphlP_w6p2gvm24AVpkqeE3iJDo9h5M&usqp=CAU",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Tailwind css",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "DevOps & Fullstack Engineering Intern",
    company: "Flipr Inovations Pvt. Ltd.",
    date: "Aug 2023 - July 2023",
    desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "Frontend Engineer Intern",
    company: "Neurobit",
    date: "June 2023 - Present",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "Fullstack Externship",
    company: "Flipr",
    date: "June 2023 - July 2023",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributing to different open-source projects and learn from industry experts",
    doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Android Developer",
    company: "DSC KIIT",
    date: "Nov2021 - Present",
    desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
  {
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    role: "Android Developer Intern",
    company: "Rudraksha Welffare Foundation",
    date: "June 2021 - Oct 2021",
    desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
    skills: [
      "Android",
      "Java",
      "Kotlin",
      "XML",
      "Node Js",
      "Cloud Firestore",
      "Firebase",
      "Figma",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Chandigarh_University_Seal.png",
    school: "Chandigarh University, Mohali, Punjab",
    date: "July 2019 - May 2023",
    grade: "7.5 CGPA",
    desc: "I hold a Bachelor's degree in Computer Science and Engineering from Chandigarh University, situated in Mohali, Punjab. Throughout eight semesters of rigorous study, I maintained a commendable cumulative grade (CGPA) of 7.5. My academic journey delved deep into a diverse spectrum of subjects, spanning from the intricacies of Data Structures and Algorithms to the complexities of Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among other fascinating domains.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering ",
  },
  {
    id: 1,
    img: "https://www.bihanichildrenacadmy.org/Content/Image/loo1.jpg",
    school: "Bihani Children's Academy, Sri Ganganagar, Rajasthan",
    date: "Apr 2018 - Apr 2019",
    desc: "I successfully concluded my class 12 high school education at Bihani Children's Academy, Sri Ganganagar, where I focused on the Science stream. Throughout my studies, I engaged with fundamental subjects such as Physics, Chemistry, and Mathematics, preparing myself for future academic and professional endeavors. Throughout my studies, I engaged deeply with fundamental subjects such as Physics, Chemistry, and Mathematics. These subjects formed the cornerstone of my academic journey, providing me with a robust understanding of the underlying principles that govern the natural world.",
    degree: "CBSE(XII), Science",
  },
];

export const projects = [
  {
    id: 9,
    title: "YouTube Lite",
    date: "Apr 2024",
    description:
      "YouTube Lite is a simplified clone of YouTube developed using React.js. It utilizes the RapidAPI to fetch video details and data. Featuring a custom video player, search functionality, and personalized suggestion pages.",
    image:
      "https://github.com/HimanshuSharmax/Task-Management-Dashboard/assets/86725419/5ab89b35-1e6e-42db-9b63-cf10c4de2bee",
    tags: [
      "React.js",
      "Router-dom",
      "UseContext",
      "js-abbreviation-number",
      "moment",
      "react-icons",
      "react-player ",
    ],
    category: "react app",
    github: "https://github.com/HimanshuSharmax/YouTube-Lite",
    webapp: "https://youtubelite-react.netlify.app/",
  },
  {
    id: 0,
    title: "Movies-House",
    date: "Mar 2022",
    description:
      "Movie House is a media-streaming website whose purpose is to show movies, trailers, ratings and there overviews. It is based on the TMDB API that provides to fetch and use its own data or images, and is built using HTML, CSS and JavaScript.",
    image:
      "https://github.com/HimanshuSharmax/Rhythm-MusicPlayer/assets/86725419/cd9f5453-f47f-45f3-b67b-ddec61ccb77e",
    tags: ["Javascript", "HTML", "CSS", "TMDB API","Genres", "media-streaming"],
    category: "javascript app",
    github: "https://github.com/HimanshuSharmax/MoviesHouse",
    webapp: "https://movieshouseapi.netlify.app/",
  },
  {
    id: 1,
    title: "Blog-Insight",
    date: "Feb 2024",
    description:
      "This is a blog-app developed in React.js that allows users to read and write blogs, add pictures and paragraphs to their blogs, and perform operations like delete and update on their blogs. The app uses Redux for state management, React-DOM for rendering, React Hooks for managing component state, and Appwrite for storing data in the database.",
    image:
      "https://github.com/HimanshuSharmax/Blog-Insight/assets/86725419/efcdf5fb-42ca-41b6-a617-2f146f86cbd3",
    tags: [
      "React Js",
      "React Hooks",
      "Appwrite",
      "Authentication",
      "Redux",
      "CRUD",
    ],
    category: "react app",
    github: "https://github.com/HimanshuSharmax/Blog-Insight",
    webapp: "https://bloginsight.netlify.app/",
  },
  {
    id: 2,
    title: "Google-Search Clone",
    date: "Dec 2022",
    description:
      "The project is a meticulously crafted replication of Google's renowned search engine, offering users the ability to seamlessly explore a vast array of topics. Powered by the robust Google Custom API. Our implementation delivers precise search results mirroring those of the original platform. Built with responsiveness in mind, our clone ensures an optimal viewing experience across various devices and screen sizes. ",
    image:
      "https://github.com/HimanshuSharmax/GoogleSearchClone/assets/86725419/a1518e9c-a694-4101-8dcc-cb085daada91",
    tags: ["React.js", "Tailwind CSS", "Google Search API", "Context API"],
    category: "react app",
    github: "https://github.com/HimanshuSharmax/GoogleSearchClone",
    webapp: "https://googlecloneapi.netlify.app/",
  },
  {
    id: 3,
    title: "Task-Management-Dashboard",
    date: "Nov 2023",
    description:
      "This project encompasses the creation of a web-based dashboard designed to facilitate efficient task management while ensuring seamless responsiveness across various devices. Developed utilizing HTML, CSS, and JavaScript, it represents a culmination of modern web development technologies.",
    image:
      "https://github.com/HimanshuSharmax/Task-Management-Dashboard/assets/86725419/0dc65767-8d36-4492-a02d-97b7e139a96a",
    tags: ["Javascript", "HTML", "CSS"],
    category: "javascript app",
    github: "https://github.com/HimanshuSharmax/Task-Management-Dashboard",
    webapp: "https://himanshusharmax.github.io/Task-Management-Dashboard/task-list.html",
  },
  {
    id: 4,
    title: "Tech-Mart E-Commerce",
    date: "May 2023",
    description:
      "The E-Commerce website, constructed utilizing React.js, presents a sophisticated platform for users to engage in browsing and purchasing activities. Seamlessly integrating modern web development practices, the website offers a comprehensive selection of electronic devices, including mobile phones, laptops, and a diverse array of accessories. Through its intuitive interface and responsive design, users can navigate the site effortlessly, enhancing their shopping experience and facilitating efficient transactions.", 
    image:
      "https://github.com/HimanshuSharmax/Tech-Mart/assets/86725419/b5ee8be2-0b8d-49f2-a7a2-27556f25dfb8",
    tags: ["React Js", "Redux", "React Router", "Node JS","Axios","Styled Components"],
    category: "react app",
    github: "https://github.com/HimanshuSharmax/Tech-Mart",
    webapp: "https://techmartshop.netlify.app/",
  },
  {
    id: 5,
    title: "Code-Editor",
    date: "Aug 2023",
    description:
      " This web-based Code Editor project allows you to write and run code in C++ and Python. It's built using HTML, CSS, JavaScript, and Node.js. The CodeMirror library and it provides a minimalistic code editing environment with syntax highlighting, code completion, and the ability to execute code.",
    image:
      "https://github.com/HimanshuSharmax/Code-Editor/assets/86725419/f741aad8-467e-46a4-9dc1-2aa896f310cb",
    tags: ["javascript", "HTML", "CSS", "Node JS", "CodeMirror"],
    category: "javascript app",
    github: "https://github.com/HimanshuSharmax/Code-Editor",
  },
  {
    id: 6,
    title: "Rhythm-MusicPlayer",
    date: "Jun 2022",
    description:
      "Rhythm is an external file music-player which allows you to go forward, backward, play, pause , shuffle and repeat a song with simple UI. It is a project that developed in Java to read data from external storage and use that data to perform operations.",
    image:
      "https://github.com/HimanshuSharmax/Task-Management-Dashboard/assets/86725419/e6411fbc-952d-44c2-9124-44c47fe735aa",
    tags: ["Android", "XML", "Java"],
    category: "android app",
    github: "https://github.com/HimanshuSharmax/Rhythm-MusicPlayer",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
